import { SplashScreen } from '@/features/splash/screens/splash-screen';
import { withAuth, withUnAuth } from '@/hocs/with-protect';
import { navigationIntegration } from '@/libs/sentry';
import { AuthStack } from '@/navigations/auth-stack';
import { DevelopmentStack } from '@/navigations/development-stack';
import { navigationRef } from '@/navigations/navigation-ref';
import type { RootStackParamList } from '@/navigations/types';
import { UnAuthStack } from '@/navigations/unauth-stack';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';
import BootSplash from 'react-native-bootsplash';

const Stack = createNativeStackNavigator<RootStackParamList>();

/**
 * Root stack: Splash, Auth, UnAuth (and Development in __DEV__).
 * initialRouteName = Splash. Splash replaces to Auth/UnAuth when done; login replaces to Auth.
 */
export function RootNavigator({ onReady }: { onReady: () => void }) {
  return (
    <NavigationContainer
      ref={navigationRef}
      onReady={() => {
        BootSplash.hide();
        navigationIntegration.registerNavigationContainer(navigationRef);
        onReady();
      }}>
      <Stack.Navigator screenOptions={{ headerShown: false }} initialRouteName="Splash">
        <Stack.Screen name="Splash" component={SplashScreen} />
        <Stack.Screen name="Auth" component={withAuth(AuthStack)} />
        <Stack.Screen name="UnAuth" component={withUnAuth(UnAuthStack)} />
        {__DEV__ && <Stack.Screen name="Development" component={DevelopmentStack} />}
      </Stack.Navigator>
    </NavigationContainer>
  );
}
